import React, { memo, useState } from "react";
import "./styles.scss";
import { Button } from "react-bootstrap";
import {
  convertSecondsIntoMinutesAndHours,
  formatAMPM,
} from "../../../utils/formater";
import TooltipComponent from "../Tooltip/Tooltip";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { clearAll } from "../../../store/testSet";
import AttemptDialog from "../../../pages/StudentPages/Practice/AttemptDialog";
import MdCalendarMonth from "../../../constants/icons/Md/MdCalendarMonth";
import BsClock from "../../../constants/icons/Bs/BsClock";
import RxStopwatch from "../../../constants/icons/Rx/RxStopwatch";
import BsCalendar4Event from "../../../constants/icons/Bs/BsCalendar4Event";

const TestPerformance = ({
  onActionHandler = () => {},
  activitesList = [],
  isMobileView = false,
  isShowLoadMore = false,
  classroomId = "",
  loadMore = () => {},
  loading = false,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const [selectedActivity, setSelectedActivity] = useState({});
  const getStartedHandler = () => {
    navigate(`/student/myClassrooms/${classroomId}/tests`);
  };
  if (activitesList.length === 0) {
    return (
      <div
        style={{
          height: "100%",
          textAlign: "center",
          alignContent: "center",
          gap: "10px",
          display: "grid",
        }}
      >
        <div style={{ fontSize: "14px", fontWeight: 600, color: "#1D2026" }}>
          No recent activity
        </div>
        {!loading && (
          <div>
            <Button
              onClick={getStartedHandler}
              className="start-classroom-styles"
              variant="outline-primary"
            >
              Get Started
            </Button>
          </div>
        )}
      </div>
    );
  }

  const onAttemptHandler = () => {
    dispatch(clearAll());
    navigate(
      `/student/myClassrooms/${classroomId}/${selectedActivity?.subjectId}/${selectedActivity?.topicId?._id}/test/testAttempt/${selectedActivity?.examId}`
    );
  };

  const onViewSolutionHandler = (activity) => {
    dispatch(clearAll());
    navigate(
      `/student/myClassrooms/${classroomId}/${activity?.subjectId}/${activity?.topicId?._id}/test/${activity?._id}/${activity?.examId}`
    );
  };

  const onAttempt = (activity) => {
    setSelectedActivity(activity);
    setOpen(true);
  };

  return (
    <div
      style={{
        padding: `${isMobileView ? "0px" : "5px 8px 0px 8px"}`,
        overflow: loading ? "hidden" : "auto", // Prevent scroll while loading
      }}
    >
      {open ? (
        <AttemptDialog
          open={open}
          setOpen={setOpen}
          practice={{
            ...selectedActivity,
            questions: { length: selectedActivity?.totalQuestions },
          }}
          onAttempt={onAttemptHandler}
          hideViewAttempts
        />
      ) : (
        ""
      )}
      {activitesList?.length &&
        activitesList.map((activity, ind) => {
          const performdate = moment(activity.createdAt).format(`Do MMMM 'YY`);
          const performTime = formatAMPM(new Date(activity.createdAt));
          const duration = convertSecondsIntoMinutesAndHours(
            activity?.timeSpent
          );
          let displayTime = "";
          if (duration.hours > 0) {
            displayTime += `${Math.ceil(duration.hours)}h `;
          }
          if (duration.minutes > 0) {
            displayTime += `${Math.ceil(duration.minutes)}m `;
          }
          if (duration.seconds) {
            displayTime += `${Math.ceil(duration.seconds)}s`;
          }
          if (
            duration.hours === 0 &&
            duration.minutes === 0 &&
            duration.seconds === 0
          ) {
            displayTime += "0s";
          }
          return (
            <>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginBottom: "8px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <div
                    style={{
                      marginRight: isMobileView ? "12px" : "24px",
                      backgroundColor: "#ebebff",
                      borderColor: "#ebebff",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      borderRadius: "5px",
                      height: "35px",
                      width: "35px",
                    }}
                  >
                    <MdCalendarMonth color="#564ffd" size={"24px"} />
                  </div>
                  <div>
                    <div
                      className="performance-title-styles"
                      style={{
                        fontSize: isMobileView ? "12px" : "",
                        fontWeight: "bold",
                        lineHeight: isMobileView ? "30px" : "",
                      }}
                    >
                      {isMobileView && activity?.name?.length > 23 ? (
                        <TooltipComponent TooltipText={activity?.name}>
                          <span>
                            {activity?.name?.slice(0, 23)}
                            ...
                          </span>
                        </TooltipComponent>
                      ) : (
                        activity?.name
                      )}
                      {!isMobileView ? (
                        <span className="dashboard-performance-topic-styles">
                          <svg
                            style={{ marginRight: "3px" }}
                            width="6"
                            height="6"
                            viewBox="0 0 11 11"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <circle
                              cx="5.81569"
                              cy="5.30592"
                              r="4.86842"
                              fill="#564ffd"
                            />
                          </svg>
                          {activity?.subjectName}
                        </span>
                      ) : (
                        ""
                      )}
                    </div>
                    {!isMobileView ? (
                      <div style={{ display: "flex" }}>
                        <div
                          style={{
                            marginRight: "24px",
                            display: "flex",
                            fontSize: "12px",
                            alignItems: "center",
                          }}
                        >
                          <RxStopwatch
                            style={{
                              marginRight: isMobileView ? "3px" : "6px",
                            }}
                            size={isMobileView ? 10 : 12}
                          />{" "}
                          {displayTime}
                        </div>
                        <div
                          style={{
                            marginRight: "24px",
                            display: "flex",
                            fontSize: "12px",
                            alignItems: "center",
                          }}
                        >
                          <BsClock
                            style={{
                              marginRight: isMobileView ? "3px" : "6px",
                            }}
                            size={isMobileView ? 10 : 12}
                          />
                          {performTime}
                        </div>
                        <div
                          style={{
                            marginRight: "24px",
                            display: "flex",
                            fontSize: "12px",
                            alignItems: "center",
                          }}
                        >
                          <BsCalendar4Event
                            style={{
                              marginRight: isMobileView ? "3px" : "6px",
                            }}
                            size={isMobileView ? 10 : 12}
                          />
                          {performdate}
                        </div>
                      </div>
                    ) : (
                      <div className="dashboard-view-details">View Details</div>
                    )}
                  </div>
                </div>
                {!loading ? (
                  <div>
                    {" "}
                    <Button
                      className={
                        isMobileView
                          ? "activity-perform-button-mobile-styles"
                          : "activity-perform-button-styles"
                      }
                      variant="outline-primary"
                      onClick={() => {
                        onViewSolutionHandler(activity);
                      }}
                    >
                      View Solution
                    </Button>
                    <Button
                      className={
                        isMobileView
                          ? "activity-perform-button-mobile-styles"
                          : "activity-perform-button-styles"
                      }
                      variant="outline-primary"
                      onClick={() => {
                        onAttempt(activity);
                      }}
                    >
                      Reattempt
                    </Button>
                  </div>
                ) : (
                  <div className="score-display">
                    <div className="score-circle">
                      <div className="score-value">
                        {activity.obtainedPoints || 0}
                      </div>
                      <div className="score-divider">/</div>
                      <div className="score-total">
                        {activity.totalPoints || 0}
                      </div>
                    </div>
                    <div className="score-label">Score</div>
                  </div>
                )}
              </div>
              <hr style={{ margin: "0px" }} />
            </>
          );
        })}
      {!loading && activitesList.length && isShowLoadMore ? (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <div>
            <Button
              className={"load-more-button-styles"}
              variant="outline-primary"
              onClick={loadMore}
            >
              {" "}
              Load More ...
            </Button>
          </div>
        </div>
      ) : (
        ""
      )}
    </div>
  );
};

export default memo(TestPerformance);
